export default "__VITE_ASSET__DRn_58tU__"